import React from 'react';

export default class NotFoundPage extends React.Component {
    render(

    ) {
        return (
            <>
                <main className="page__main">
                    <div className="container page-not-found">
                        <p className="page-not-found__description">К сожалению, запрашиваемая вами
                            страница&nbsp;не&nbsp;найдена.</p>
                        <img className="page-not-found__thumbnail" src="/images/pic--404.png" alt='' />
                        <a className="button button--accent-light page-not-found__link" href="/">На главную</a>
                    </div>
                </main>
            </>
        )
    }
}
